import { Calendar } from "antd";
import styled from "styled-components";

export const CalendarWithoutModeSelect = styled(Calendar)`
  .ant-picker-calendar-mode-switch {
    display: none;
  }
`;
